// extracted by mini-css-extract-plugin
module.exports = {"two-col":"_3SQH-","twoCol":"_3SQH-"};